var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enableApproveBilling)?_c('base-container',{attrs:{"vertical-center":"","horizontal-center":""}},[_c('billing-approve-status-label',{attrs:{"status":_vm.status}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }